import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-view-products',
    templateUrl: './view-products.component.html',
    styleUrls: ['./view-products.component.scss'],
    standalone: false
})
export class ViewProductsComponent {
@Input() brandWithProducts: any;
@Input() isLoading: boolean = false;

ngOnInit() {
  this.brandWithProducts.brandName = this.brandWithProducts.brandName || this.brandWithProducts.name; 
  this.brandWithProducts.products.forEach((product: any) => {
      product['productName'] = product.name || product['productName']; // Fallback to 'name' if 'productName' is undefined
    })
  }
}
